$(document).ready(function () {
  "use strict";
  // navbar js start ---
  $(window).on("load scroll", function () {
    var scrolling = $(this).scrollTop();
    if (scrolling > 10) {
      $(".navbar").addClass("nav-fixed");
    } else {
      $(".navbar").removeClass("nav-fixed");
    }
  });

  $(".ham-menu").click(function (event) {
    event.stopPropagation();
    $(".nav-link-wrapper").toggleClass("active");
    $(".ham-menu").toggleClass("active");
    $(".nav-link-wrapper-inner").toggleClass("active");
    $("body").toggleClass("active");
  });

  $(".mobile-menu-close-window-btn").click(function (event) {
    event.stopPropagation();
    $(".nav-link-wrapper").toggleClass("active");
    $(".ham-menu").toggleClass("active");
    $(".nav-link-wrapper-inner").toggleClass("active");
    $("body").toggleClass("active");
  });

  // mobile-dropdown responsive accordion js start--
  $(function () {
    const isMobile = window.matchMedia(
      "only screen and (max-width: 992px)"
    ).matches;
    if (isMobile) {
      // ..mobile-dropdown-accordion js start..
      $(".dropdown-btn").on("click", function () {
        $(this).next(".child-menu-wrap").slideToggle();
        $(this).toggleClass("active");
      });
      // ..mobile-dropdown-accordion js end..

      // ..mobile-sub-dropdown-accordion js start..
      $(".sub-dropdown-btn").on("click", function () {
        $(this).children(".grandchild-menu-wrap").slideToggle();
      });
      // ..mobile-sub-dropdown-accordion js end..
    }
  });
  // mobile-dropdown responsive accordion js end--

  $(".search-bar-open-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar").toggleClass("active");
    $(".search-bar-window-close-btn").toggleClass("active");
    $("body").toggleClass("active");
    $(".search-input").focus();
  });

  $(".search-bar-window-close-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar").toggleClass("active");
    $(this).toggleClass("active");
    $("body").toggleClass("active");
  });

  $(".search-close-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar").toggleClass("active");
    $(".search-bar-window-close-btn").toggleClass("active");
    $("body").toggleClass("active");
  });

  // navbar js end ---

  // filter sidebar js start--
  $(".filter-open-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-filter").addClass("active");
    $("body").toggleClass("active");
  });

  $(".filter-window-close-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-filter").removeClass("active");
    $("body").toggleClass("active");
  });

  $(".filter-close-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-filter").removeClass("active");
    $("body").toggleClass("active");
  });
  // filter sidebar js end--

  // **..filter-accordion js start..**
  $(".accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
  });
  // **..filter-accordion js end..**

  // tab content item scroll js start---
  // $(".tabs-content-items").niceScroll();
  // tab content item scroll js start---

  // **..product-accordion js start..**
  $(".product-accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active")
      .find(".product-accordion-item-content")
      .slideUp();
  });
  // **..product-accordion js end..**

  // **..faq-accordion js start..**
  $(".faq-accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active")
      .find(".faq-accordion-item-content")
      .slideUp();
  });
  // **..product-accordion js end..**

  // product quantity js start--//
  $(".qty-increase").click(function () {
    // $("#quantity").val(parseInt($(".quantity-total").val()) + 1);
    $(".single-quantity-total").val(
      parseInt($(".single-quantity-total").val()) + 1
    );
  });

  $(".qty-decrease").click(function () {
    var currentValue = parseInt($(".single-quantity-total").val());
    if (currentValue > 1) {
      $(".single-quantity-total").val(currentValue - 1);
      // $("#quantity").val(currentValue - 1);
    }
  });

  // // Change image when product option changes
  // $(".option_input").on("change", function () {
  //   let optionName = "";

  //   // Get selected option value
  //   $("input:radio.option_input:checked").each(function (e) {
  //     optionName += e !== 0 ? "-" : "";
  //     optionName += $(this).val();
  //   });

  //   $("#productSelect option").each(function () {
  //     var txt = $.trim($(this).text());
  //     if (txt === optionName) {
  //       var img = $(this).data("img");
  //       var id = $(this).val();
  //       var price = $(this).data("price");
  //       var compare_price = $(this).data("compare");
  //       var available = $(this).data("available");
  //       $("#productSelect").val(id);
  //       $("#product_id").val(id);

  //       if (available) {
  //         $(".atc-text").removeClass("sold_out").text("Add To Cart");
  //       } else {
  //         $(".atc-text").addClass("sold_out").text("Sold Out");
  //       }

  //       $(".thumb_image img").each(function (index) {
  //         var src = $(this).attr("src").split("?")[0]; // Remove query parameters
  //         var cleanImg = img.split("?")[0];
  //         if (src === cleanImg) {
  //           swiper2.slideToLoop(index, 500, false);
  //           $(".thumb_image").removeClass("active"); // Remove active class from all
  //           $(this).closest(".thumb_image").addClass("active"); // Add to selected
  //         }
  //       });
  //     }
  //   });
  // });

  $(".addToCart").on("click", function (e) {
    e.preventDefault();

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: $("#single_form").serialize(),
      dataType: "json",
      success: function (data) {
        // console.log(data);
        $("body").addClass("cartShown");
        cart_drawer_update();
      },
      error: function (err) {
        console.log("Error", err);
      },
    });
  });

  $(".search-open").click(function (event) {
    event.stopPropagation();
    $(".search-bar").addClass("active1");
    $("#ajax-search-input").focus();
  });

  // $(".search-close-btn, .search-bar-overlay").click(function (event) {  [ previous code ]
  $(".search-close-btn, .search-bar-window-close-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar").removeClass("active1");
    console.log("overlay clicked!");
    $(".search-result-heading").removeClass("search-result-heading-show");
  });

  $(".search-input").on("input", function (e) {
    if ($(".search-input").val() != "") {
      $(".search-result-heading").addClass("search-result-heading-show");
    } else {
      $(".search-result-heading").removeClass("search-result-heading-show");
    }
  });

  // cart-sidebar js start---
  $(".cart-sidebar-open-btn").click(function (event) {
    event.stopPropagation();
    // $(".cart-sidebar").toggleClass("active");
    $("body").toggleClass("cartShown");
  });

  $(".cart-sidebar-close-window-btn").click(function (event) {
    event.stopPropagation();
    // $(".cart-sidebar").removeClass("active");
    $("body").toggleClass("cartShown");
  });

  $(".side-cart-close-btn").click(function (event) {
    event.stopPropagation();
    // $(".cart-sidebar").toggleClass("active");
    $("body").toggleClass("cartShown");
  });
});

// related-product slider js start--
var swiper = new Swiper(".side-cart-slider", {
  slidesPerView: 2.2,
  spaceBetween: 10,
  grabCursor: true,
  loop: false,
  speed: 1000,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
// related-product slider js end--

// progesss-bar js start--
const progress = document.querySelector(".progress");
progress.addEventListener("input", function () {
  const value = this.value;
  this.style.background = `linear-gradient(to right,rgb(36, 40, 51) 0%,rgb(36, 40, 51) ${value}%,rgb(216, 216, 216) ${value}%)`;
});

// btn js ---
// primary btn---
$(function () {
  $(".primary-btn")
    .on("mouseenter", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    })
    .on("mouseout", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    });
});

// secondary btn--
$(function () {
  $(".secondary-btn")
    .on("mouseenter", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    })
    .on("mouseout", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    });
});
// btn js ---

// banner slider js start--
var swiper = new Swiper(".top-bar-slider", {
  slidesPerView: 1,
  loop: true,
  speed: 1000,
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
});
// banner slider js end--

// banner slider js start--
var swiper = new Swiper(".banner-slider", {
  slidesPerView: 1,
  grabCursor: true,
  loop: true,
  speed: 1000,
  effect: "fade",
  // autoplay: {
  // 	delay: 3500,
  // 	disableOnInteraction: false,
  // },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
// banner slider js end--

// product-slider js start---
var swiper = new Swiper(".product-slider-thumb", {
  direction: "vertical",
  loop: true,
  spaceBetween: 20,
  slidesPerView: 5,
  freeMode: true,
  mousewheel: true,
  breakpoints: {
    // when window width is >= 320px
    1: {
      direction: "horizontal",
      spaceBetween: 10,
      slidesPerView: 4,
    },
    // when window width is >= 576px
    576: {
      direction: "horizontal",
      spaceBetween: 20,
      slidesPerView: 5,
    },
    // when window width is >= 767px
    768: {
      direction: "vertical",
      spaceBetween: 20,
      slidesPerView: 5,
    },
  },
});
var swiper2 = new Swiper(".product-slider", {
  loop: true,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});
// product-slider js end---

// related-product slider js end--

// modal js start---
var body = document.querySelector("body");
var modal = document.querySelector(".masurement-modal");
var measurement_guide_modal_btn = document.querySelector(
  ".measurement-guide-modal-btn"
);
var closeButton = document.querySelector(".modal-close-button");

function toggleModal() {
  modal.classList.toggle("show-modal");
  body.classList.toggle("active");
}

function windowOnClick(event) {
  if (event.target === modal) {
    toggleModal();
  }
}

measurement_guide_modal_btn.addEventListener("click", toggleModal);
closeButton.addEventListener("click", toggleModal);
window.addEventListener("click", windowOnClick);
// modal js end---

// content animation--
new WOW().init();
